<template>
  <v-dialog ref="dialog" v-model="modal" :return-value.sync="value" persistent width="290px">
    <template v-slot:activator="{ on }">
      <v-container v-on="on" style="cursor: pointer">
        <v-input>{{label ? label : "Color"}}</v-input>
        <v-list-item-avatar>
          <v-avatar v-if="value" :color="value" size="60" class="elevation-20">
            <v-icon>mdi-pencil</v-icon>
          </v-avatar>
          <v-avatar v-else color="#ECEFF1FF" size="60">
            <v-icon>mdi-pencil</v-icon>
          </v-avatar>
        </v-list-item-avatar>
      </v-container>
    </template>
    <v-card>
      <v-color-picker v-model="color" show-swatches hide-canvas hide-inputs type="hex"></v-color-picker>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modal = false">{{$t("cancel")}}</v-btn>
        <v-btn text color="primary" @click="changeColor(color)">{{$t("confirm")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["value", "label", "format"],
  data() {
    return {
      color: "",
      modal: false
    };
  },
  watch: {
    value() {
      if (this.value) {
        this.color = this.value;
      } else {
        this.color = "";
      }
    }
  },
  methods: {
    changeColor(value) {
      this.$refs.dialog.save(value);
      this.$emit("input", value);
    }
  },
  mounted() {}
};
</script>